import React, { useState, useEffect } from "react";
import { Box, Typography, Paper, CircularProgress } from "@mui/material";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import GroupsIcon from "@mui/icons-material/Groups";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DiamondIcon from "@mui/icons-material/Diamond";
import PeopleIcon from "@mui/icons-material/People";
import StarIcon from "@mui/icons-material/Star";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
export default function Dashboard() {
    const [datasource, setDatasource] = useState([]);    
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        fetchDasboardData();
    }, []);
    const fetchDasboardData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "dashboard/summary";
            const response = await makeRequest("get", url);
            if (response) {
                setDatasource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const cardData = [
        { title: "Total Products", value: datasource?.total_products ? datasource?.total_products : 0, icon: <Inventory2Icon sx={{ fontSize: 40 }} />, color: "#4caf50" },
        { title: "Total Users", value: datasource?.total_users ? datasource?.total_users : 0, icon: <GroupsIcon sx={{ fontSize: 40 }} />, color: "#ff9800" },
        { title: "Today's Income", value: `₹ ${datasource?.today_income ? datasource?.today_income : 0}`, icon: <MonetizationOnIcon sx={{ fontSize: 40 }} />, color: "#9c27b0" },
        { title: "This Month Income", value: `₹ ${datasource?.monthly_income ? datasource?.monthly_income :0 }`, icon: <CalendarTodayIcon sx={{ fontSize: 40 }} />, color: "#00bcd4" },
        { title: "Total Orders", value: datasource?.total_orders ? datasource?.total_orders : 0, icon: <StarIcon sx={{ fontSize: 40 }} />, color: "#2196f3" },
        { title: "Pending Orders", value: datasource?.pending_orders ? datasource?.pending_orders : 0, icon: <DiamondIcon sx={{ fontSize: 40 }} />, color: "#c40707" },
        { title: "Total Staffs", value: datasource?.total_staff ? datasource?.total_staff : 0, icon: <PeopleIcon sx={{ fontSize: 40 }} />, color: "#c40707" },
    ];
    return (
        <Box sx={{ p: 3 }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h5" sx={{ mb: 4, fontWeight: 500 }}>Dashboard</Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
                {cardData.map((card, index) => (
                    <Paper key={index} elevation={1} sx={{ display: "flex", alignItems: "center", p: 3, borderRadius: 3, backgroundColor: card.color, color: "#fff", width: 450, minHeight: 200 }}>
                        <Box sx={{ mr: 3 }}>{card.icon}</Box>
                        <Box>
                            <Typography variant="h6" sx={{ fontWeight: 500 }}>{card.title}</Typography>
                            <Typography variant="h3" sx={{ fontWeight: 700, mt: 0.5 }}>{card.value}</Typography>
                        </Box>
                    </Paper>
                ))}
            </Box>
        </Box>
    );
}